import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { Person } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PersonService extends DataService<unknown> {
  route: string;

  persons: Person[];

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/person',
      httpClient,
      httpFactory
    );
  }

  getPersons(): Observable<Person[]> {
    return this.httpClient.get<Person[]>(`${this.route}`);
  }

  addPerson(personData: Person): Observable<void> {
    return this.httpClient.post<void>(`${this.route}`, personData);
  }
}
